import type { labelProviderInterface } from '../../../LabelProviderInterface';
import dynamicBannerStore from '../conversational-search-banners/dynamic/dynamic-banner-mediator/dynamic-banner-store';
import { setCTAActionSessionStorageValue } from '../conversational-search-logic/storage-manager/storage-manager-helpers';
import type { WidgetConversationalSearchBannerMediator } from './conversational-search-banner-mediator';

export const bannersCallback =
  (context: WidgetConversationalSearchBannerMediator) =>
    (clickedArea = '', keyword?: string) => {
        setCTAActionSessionStorageValue();
        context.conversationalSearchCtaActionEventEmitter.emit({
          isChatVisible: true,
          isGuidedSearch: context.isGuidedVariant,
        });

        context.gaCtaBannerClickedEventEmitter.emit({
          isZeroResultPage: context.isZeroResult,
          isGuided: context.isGuidedVariant,
          keyword: keyword ?? context.term,
          clickedArea: clickedArea,
          isRefinement: dynamicBannerStore.get('isRefinement')
        });
    };

export const getCtaText = (labelProvider: labelProviderInterface) => {
    return labelProvider(
      'conversational.search.banner.cta.ask.question',
      'Ask a product question',
    );
};